import { useTranslations } from 'next-intl';

export type CropOption = { label: string; value: number | 'free' };

const DEFAULT_CROP_OPTIONS = [
  {
    label: '16:9',
    value: 16 / 9,
  },
  {
    label: '9:16',
    value: 9 / 16,
  },
  {
    label: '4:3',
    value: 4 / 3,
  },
  {
    label: '3:4',
    value: 3 / 4,
  },
  {
    label: '1:1',
    value: 1 / 1, //强迫格式一致
  },
];

export default function useCropOptions() {
  const t = useTranslations();

  const freeAspectOption: CropOption = {
    label: t('imgCropModal.free'),
    value: 'free',
  };

  return { freeAspectOption, defaultCropOptions: DEFAULT_CROP_OPTIONS };
}
